import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href", "target"]
const _hoisted_2 = {
  key: 1,
  class: "h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
}
const _hoisted_3 = {
  key: 1,
  class: "h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
}
const _hoisted_4 = ["type", "disabled"]
const _hoisted_5 = {
  key: 1,
  class: "h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($props.href)
    ? (_openBlock(), _createElementBlock("a", _mergeProps({
        key: 0,
        href: $props.href,
        target: $props.target,
        class: $setup.classes
      }, _ctx.$attrs), [
        ($setup.iconComponent && !$props.loading)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.iconComponent), {
              key: 0,
              size: $setup.iconSize,
              "stroke-width": 2.2,
              class: "shrink-0"
            }, null, 8, ["size"]))
          : _createCommentVNode("", true),
        ($props.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString($props.loading ? $props.loadingText : $props.label), 1)
        ])
      ], 16, _hoisted_1))
    : ($props.to)
      ? (_openBlock(), _createBlock(_component_router_link, _mergeProps({
          key: 1,
          to: $props.to,
          class: $setup.classes
        }, _ctx.$attrs), {
          default: _withCtx(() => [
            ($setup.iconComponent && !$props.loading)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.iconComponent), {
                  key: 0,
                  size: $setup.iconSize,
                  "stroke-width": 2.2,
                  class: "shrink-0"
                }, null, 8, ["size"]))
              : _createCommentVNode("", true),
            ($props.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["to", "class"]))
      : (_openBlock(), _createElementBlock("button", _mergeProps({
          key: 2,
          type: $props.type,
          disabled: $props.disabled || $props.loading,
          class: $setup.classes
        }, _ctx.$attrs), [
          ($setup.iconComponent && !$props.loading)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.iconComponent), {
                key: 0,
                size: $setup.iconSize,
                "stroke-width": 2.2,
                class: "shrink-0"
              }, null, 8, ["size"]))
            : _createCommentVNode("", true),
          ($props.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString($props.loading ? $props.loadingText : $props.label), 1)
          ])
        ], 16, _hoisted_4))
}